import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../types'
import {
  fetchPlannableStats,
  type FetchPlannableStatsOptions
} from '../plannables.api'
import { plannablesCacheKeys } from '../plannables.cacheKeys'
import type { PlannableStatsResponse } from '../types/PlannableStats'

export const useFetchPlannableStats = (
  opts: FetchPlannableStatsOptions,
  queryOptions?: UseAppQueryOptions<PlannableStatsResponse>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: plannablesCacheKeys.plannableStats.all(opts.queryParams),
    queryFn: () => fetchPlannableStats(opts)
  })
}
